import Vue from 'vue';
import {
  GET_SERVICES_REQUEST,
  GET_SERVICES_SUCCESS,
  GET_SERVICES_ERROR,
  GET_CLIENT_SERVICES_REQUEST,
  GET_CLIENT_SERVICES_SUCCESS,
  GET_CLIENT_SERVICES_ERROR,
  UPDATE_CLIENT_SERVICES_REQUEST,
  UPDATE_CLIENT_SERVICES_SUCCESS,
  UPDATE_CLIENT_SERVICES_ERROR,
  UPDATE_USER_SERVICE_REQUEST,
  UPDATE_USER_SERVICE_SUCCESS,
  UPDATE_USER_SERVICE_ERROR
} from './actionTypes';
import serviceApi from '../../_api/service';

const state = {
  services: [],
  client_services: {},
  status: '',
  errors: [],
  hasLoadedOnce: false
};

const getters = {
  services: (state) => state.services,
  client_services: (state) => state.client_services
};

const actions = {
  [GET_SERVICES_REQUEST]: ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      commit(GET_SERVICES_REQUEST);
      serviceApi
        .getServices()
        .then((response) => {
          commit(GET_SERVICES_SUCCESS, response);
          resolve(response);
        })
        .catch((error) => {
          commit(GET_SERVICES_ERROR, error);
          reject(error);
        });
    });
  },
  [GET_CLIENT_SERVICES_REQUEST]: ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      commit(GET_CLIENT_SERVICES_REQUEST);
      serviceApi
        .getClientServices(payload)
        .then((response) => {
          commit(GET_CLIENT_SERVICES_SUCCESS, response);
          resolve(response);
        })
        .catch((error) => {
          commit(GET_CLIENT_SERVICES_ERROR);
          reject(error);
        });
    });
  },

  [UPDATE_CLIENT_SERVICES_REQUEST]: ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      commit(UPDATE_CLIENT_SERVICES_REQUEST);
      serviceApi
        .updateClientServices(payload)
        .then((response) => {
          commit(UPDATE_CLIENT_SERVICES_SUCCESS, response);
          resolve(response);
        })
        .catch((error) => {
          commit(UPDATE_CLIENT_SERVICES_ERROR, error);
          reject(error);
        });
    });
  },
  [UPDATE_USER_SERVICE_REQUEST]: ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      commit(UPDATE_USER_SERVICE_REQUEST);
      serviceApi
        .updateUserService(payload)
        .then((response) => {
          commit(UPDATE_USER_SERVICE_SUCCESS, response);
          resolve(response);
        })
        .catch((error) => {
          commit(UPDATE_USER_SERVICE_ERROR, error);
          reject(error);
        });
    });
  }
};

const mutations = {
  [GET_SERVICES_REQUEST]: (state) => {
    state.status = 'loading';
  },
  [GET_SERVICES_SUCCESS]: (state, response) => {
    state.status = 'success';
    state.hasLoadedOnce = true;
    Vue.set(state, 'services', response.data);
  },
  [GET_SERVICES_ERROR]: (state, response) => {
    state.status = 'error';
    state.hasLoadedOnce = true;
    Vue.set(state, 'errors', response.error);
  },

  [GET_CLIENT_SERVICES_REQUEST]: (state) => {
    state.status = 'loading';
  },
  [GET_CLIENT_SERVICES_SUCCESS]: (state, response) => {
    state.status = 'success';
    state.hasLoadedOnce = true;
    Vue.set(state, 'client_services', response.data);
  },
  [GET_CLIENT_SERVICES_ERROR]: (state, response) => {
    state.status = 'error';
    state.hasLoadedOnce = true;
    Vue.set(state, 'errors', response.error);
  },

  [UPDATE_CLIENT_SERVICES_REQUEST]: (state) => {
    state.status = 'loading';
  },
  [UPDATE_CLIENT_SERVICES_SUCCESS]: (state, response) => {
    state.status = 'success';
    state.hasLoadedOnce = true;
    Vue.set(state, 'service', response.data);
  },
  [UPDATE_CLIENT_SERVICES_ERROR]: (state, response) => {
    state.status = 'error';
    state.hasLoadedOnce = true;
    Vue.set(state, 'errors', response.error);
  },

  [UPDATE_USER_SERVICE_REQUEST]: (state) => {
    state.status = 'loading';
  },
  [UPDATE_USER_SERVICE_SUCCESS]: (state, response) => {
    state.status = 'success';
    state.hasLoadedOnce = true;
    Vue.set(state, 'service', response.data);
  },
  [UPDATE_USER_SERVICE_ERROR]: (state, response) => {
    state.status = 'error';
    state.hasLoadedOnce = true;
    Vue.set(state, 'errors', response.error);
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
